// extracted by mini-css-extract-plugin
export default {"requests":"styles_requests__g0HqO"};